import { createContext, ReactNode, useContext } from "react";
export interface Color {
  primaryColor: string | undefined | null;
  secondColor: string | undefined | null;
  thirdColor?: string | undefined | null;
  forthColor?: string | undefined | null;
  fifthColor?: string | undefined | null;
}
export type ThemeContentType = {
  colors: Color;
  setTheme: (c: Color) => void;
};

const ThemeContext = createContext<ThemeContentType | undefined>(undefined);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

type ThemeProviderProps = {
  children: ReactNode;
  colors: Color;
  setTheme: (theme: Color) => void;
};

export const ThemeProvider = ({
  children,
  colors,
  setTheme,
}: ThemeProviderProps) => {
  // const [colors, setTheme] = useState<Color>({
  //   primaryColor: null,
  //   secondaryColor: null,
  // });

  return (
    <ThemeContext.Provider value={{ colors, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
